
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Navigation, Router } from '@angular/router';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke331aRequest, Sgke331aResponseSearchresultList, Szza012aRequest } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke331aService } from '../../services/used-sgke331a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke330d',
  templateUrl: './sgke330d.component.html',
  styleUrl: './sgke330d.component.scss'
})
export class Sgke330dComponent implements OnInit, OnDestroy, AfterViewInit {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 検索結果リスト */
  searchresultList: Array<Sgke331aResponseSearchresultList> = new Array<Sgke331aResponseSearchresultList>();
  /** sgke331aFormGroup */
  sgke331aReqForm = new UntypedFormGroup({});

  /** 業務日付_日付型 */
  todayDate: Date;
  /** 業務日付_文字列型 */
  todayStr: string;

  /** ナビゲーション */
  nav: Navigation | null;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  // エラーメッセージ表示制御
  isErrorMessageDisplay: boolean = true;

  /**
   * コンストラクタ
   * @param {MatDialog} dialog
   * @param {UsedSgke331aService} initService
   * @param {ChangeDetectorRef} cd
   * @param {TimeApiService} timeApiService
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {Router} router 
   * @memberof Sgke330dComponent
   */
  constructor(
    public dialog: MatDialog,
    public getDateService: UsedSzza012aService,
    public initService: UsedSgke331aService,
    private cd: ChangeDetectorRef,
    private timeApiService: TimeApiService,
    private responseMsgUtils: ResponseMsgUtils,
    private router: Router,
  ) {
    this.nav = this.router?.getCurrentNavigation();
  }

  /**
   * 初期処理
   * @memberof Sgke330dComponent
   */
  ngOnInit(): void {


    // SZZA012Aのリクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null,
    };

    // SZZA012A呼び出し
    this.getDateService
      .doSzza012a(this.requestSzza012a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {
          if (response?.todayDay) {
            this.todayStr = response.todayDay;
            this.todayDate = this.timeApiService.convertStringToDate(
              response.todayDay
            );
          }
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        },
        (error) => {
        },
        () => {
          // 業務日付取得後、SGKE331A呼び出し
          this.sgke331aCall();
          this.cd.detectChanges();
        }
      );
  }

  /**
   * 画面描画後初回処理
   * @memberof Sgke330dComponent
   */
  ngAfterViewInit(): void {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(this.nav?.extras?.state?.['errors'], this.errorMessageModelArray);
  }

  /**
   * 購読解除
   * @memberof Sgke330dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * SGKE331A_担当作業一覧初期表示API呼出し
   * @param {boolean} [onSubmitFlg=false] ボタン押下時=TRUE, 初期表示時=FALSE
   * @param {boolean} [isTodayButton=false] 当日分ボタン押下時=TRUE, 検索ボタン押下時=FALSE
   * @memberof Sgke330dComponent
   */
  sgke331aCall(onSubmitFlg: boolean = false, isTodayButton: boolean = false) {
    if (!this.nav) {
      this.errorMessageModelArray = new Array<SgAriaMessage>();
    }
    this.cd.detectChanges();
    let requestInfo: Sgke331aRequest

    // SGKE331Aリクエスト作成
    // 初期表示、もしくは当日分ボタン押下の場合、以下リクエストを作成
    if (!onSubmitFlg || isTodayButton) {
      requestInfo = {
        requestCommon: undefined,
        cndt: {
          workymdStart: null,
          workymdEnd: this.todayStr,
          resultRegzumiFlg: false
        }
      }
      // ボタン押下で呼び出されている、かつ検索ボタン押下の場合、検索条件フォームからリクエストを作成
    } else {
      requestInfo = this.sgke331aReqForm.getRawValue() as Sgke331aRequest;
    }

    // SGKE331A呼び出し
    this.initService.doSgke331a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response.searchresultList) {
          this.searchresultList = response?.searchresultList;
          this.cd.detectChanges();
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });

  }

  /**
   * 検索ボタン押下時処理
   * @param {SubmitEvent} event
   * @memberof Sgke330dComponent
   */
  onClickSearch(event: SubmitEvent): void {
    // エラーメッセージのクリア
    this.clearErrorMsg();
    // searchresultList初期化
    this.searchresultList = new Array<Sgke331aResponseSearchresultList>() ;

    // 当日分ボタンを押下された場合、isTodayButtonをTRUEにする
    let isTodayButton = event.submitter.id === 'today' ? true : false;

    // SGKE331A_担当作業一覧初期表示API呼出し
    this.sgke331aCall(true, isTodayButton);

  }


  /**
    * モーダル表示非表示イベント時の処理
    * @param isDisplay 表示非表示判定イベント boolean
    */

  /**
   * モーダル表示非表示イベント時の処理
   * @param isDisplay 表示非表示判定イベント boolean
   * @memberof Sgke330dComponent
   */
  onModalIsDisplay(isDisplay: boolean): void {
    // モーダル表示非表示イベント時、エラーメッセージ表示エリア表示非表示を切り替える
    // true 表示する
    // false 非表示にする
    this.isErrorMessageDisplay = isDisplay;
  };
  
  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke330dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

}
